module.exports = __webpack_public_path__ + "img/block_bg2.1e7318d2.webp";